// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-container[data-v-980aa514] {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
